import React,{Component} from 'react';
import {Modal} from 'react-bootstrap';
import {Link, browserHistory} from 'react-router';
import $ from 'jquery';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class CheckoutFlow extends Component{
   constructor(props){  
    super(props);
    this.state={
     
    }
  }  

  render()
  {    

    document.title ="AquaDeals - Online AquaCulture MarketPlace, Find best deals on Seed, Feed, Health Care, Machinery & Farm Equipments, Products, Ropes & Nets Paddle Wheels and More | AquaDeals";
    document.getElementsByTagName("META")[2].content="It is a place for deals related to Aqua culture";
	  
  return(
		<div className="mob_deals mob_advertise_page">	
			    <div className="page_hdr">
            <div className="container-fluid">
              <h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>Advertise With Us</h5>
              <a href="/home" className="home_logo1"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home" /></a>
            </div>
          </div>
          <div className="pag_cntnt">&nbsp;</div>
			  <div className="container-fluid mob_advertise_blk">	 
			     <div style={{textAlign:'center'}}>
            <h1>Checkout Flow</h1><br/>
            <div><img src={require('../../../assets/images/check_out_mob.png')}  /></div>  
           </div>  
			  </div> 
		 </div>
	);
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Categories/Common/CheckoutFlow.js
 **/